import { useState } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { Cost } from '@r1-frontend/ui-react/experimental/purchase/cost';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

const periodText = getPluralize(monthPluralize);

export type TAdditionProductDetailedInfoProps = {
    productName: string,
    period: number,
    finalPrice: number,
    startPrice: number | null,
}

const AdditionalProductDetailedInfo = (
    {
        productName,
        period,
        finalPrice,
        startPrice,
    }: TAdditionProductDetailedInfoProps,
): JSX.Element => {
    const [isOpen, changePopupState] = useState(false);

    const handleClosePopup = () => {
        changePopupState(false);
    };

    const handleOpenPopup = () => {
        changePopupState(true);
    };

    return (
        <>
            <ControlElement type={'large'} Icon={InfoCircleFlip} onClick={handleOpenPopup}>Условия приобретения</ControlElement>

            <DefaultPopup isOpen={isOpen} onClose={handleClosePopup}>
                <IndentContainer $desktop={[32]} $mobile={[24]}>
                    <TextWrapper>
                        <H3 style={{ paddingRight: 36 }}>{productName}&nbsp;&mdash; условия приобретения</H3>
                        <Paragraph4 $color={COLORS.TextInfo}>
                            Оборудование в рассрочку за <Cost isMonthly={true}>{finalPrice}</Cost> включено в стоимость тарифа.
                            {startPrice !== null && (<>&nbsp;При этом в первый месяц цена <Cost isMonthly={true}>{startPrice}</Cost>.</>)}
                            &nbsp;Через {period} {periodText(period)} оборудование перейдет к вам в собственность.
                        </Paragraph4>
                    </TextWrapper>

                    <ButtonGroup>
                        <Button bType={'action'} size={'large'} onClick={handleClosePopup}>Закрыть</Button>
                    </ButtonGroup>
                </IndentContainer>
            </DefaultPopup>
        </>
    );
};

export default AdditionalProductDetailedInfo;
